import { SubMenuComponent } from '../sub-menu';
import { messages } from '../../../i18n';
import {
  DOCUMENTATION_LINK,
  SUGAR_CLUB_LINK,
  TRAINING_LINK,
  PRIVACY_POLICY_LINK,
} from '../../../common';
import { MenuItemList, MenuItem } from './help-sub-menu.styles';
import { HelpIcon, SugarIcon } from '../../../icons';
import { Fragment, useContext } from 'react';
import { SideNavSubMenuContext } from '../sidebar-navigation.context';
import classnames from 'classnames';
import { NavTooltip, SidebarNavItemOption } from '../sidebar-navigation.styles';

export const helpSubMenuItems = [
  {
    key: messages.nav.trainingCertification,
    link: TRAINING_LINK,
    label: messages.nav.trainingCertification,
    icon: <SugarIcon icon={'sugar-u'} />,
  },
  {
    key: messages.nav.sugarClubCommunity,
    link: SUGAR_CLUB_LINK,
    label: messages.nav.sugarClubCommunity,
    icon: <SugarIcon icon={'sugar-club'} />,
  },
  {
    key: messages.nav.documentationSupport,
    link: DOCUMENTATION_LINK,
    label: messages.nav.documentationSupport,
    icon: <SugarIcon icon={'document-lg'} />,
  },
  {
    key: messages.nav.privacyPolicy,
    link: PRIVACY_POLICY_LINK,
    label: messages.nav.privacyPolicy,
    icon: <SugarIcon icon={'data-privacy-lg'} />,
  },
];

export const HelpSubMenu = ({ onToggle }) => {
  const { doOpen, isOpen } = useContext(SideNavSubMenuContext);

  return (
    <div
      className={classnames('sidebar-nav-item', {
        selected: isOpen,
      })}
      onClick={doOpen}
    >
      <div className='sidebar-nav-item-btn'>
        <span className='animated-background' />

        <NavTooltip
          title={messages.nav.viewDocumentation}
          className={'collapsed'}
        >
          <Fragment>
            <HelpIcon size={18} hover />
            <span className='sidebar-nav-item-tab' />
          </Fragment>
        </NavTooltip>

        <SidebarNavItemOption className='expanded sidebar-nav-item-option'>
          <HelpIcon size={18} hover />

          <span>{messages.nav.viewDocumentation}</span>
        </SidebarNavItemOption>
      </div>

      <SubMenuComponent
        noBorder={true}
        onToggle={onToggle}
        labels={{
          title: messages.nav.viewDocumentation,
        }}
        menuItems={[]}
      >
        <MenuItemList>
          {helpSubMenuItems.map(({ key, link, icon, label }) => (
            <MenuItem key={key}>
              <a href={link} target='_blank' rel='noopener noreferrer'>
                {icon}
                <span>{label}</span>
              </a>
            </MenuItem>
          ))}
        </MenuItemList>
      </SubMenuComponent>
    </div>
  );
};
